import {createSelector} from 'reselect';

const getUser = (store) => store.user || {};

const userSelector = createSelector(getUser, (user) => user);

export default {
    user: (store) => userSelector(store),
};
